export default "__VITE_ASSET__BzeRs2uE__"